import Image from "next/image";
const LogoAndText = ({ imgUrl, text, h, w }) => {
  return (
    <div id={`logo-and-text-${text.split(' ').join('-').toLowerCase()}`} className="flex flex-row gap-3 text-black">
      <Image
        id={`logo-image-${text.split(' ').join('-').toLowerCase()}`}
        alt="Some image"
        src={imgUrl}
        height={h}
        width={w}
      />
      <p id={`logo-text-${text.split(' ').join('-').toLowerCase()}`} className="text-sm">
        {text}
      </p>
    </div>
  );
};

export default LogoAndText;
